import { render, staticRenderFns } from "./create-organization-modal.vue?vue&type=template&id=543409b7&scoped=true&"
import script from "./create-organization-modal.vue?vue&type=script&lang=js&"
export * from "./create-organization-modal.vue?vue&type=script&lang=js&"
import style0 from "./create-organization-modal.vue?vue&type=style&index=0&id=543409b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543409b7",
  null
  
)

export default component.exports